// layout/DeviceContext.js
import React, { createContext, useState, useContext } from "react";

const DeviceContext = createContext();

export const DeviceProvider = ({ children }) => {
    const [selectedDevice, setSelectedDevice] = useState(null);
    const [metrics, setMetrics] = useState({
        cpu: 0, memory: 0, temp: 0, uptime: "N/A", last_updated: "",
        device_info: { model: "N/A", mac: "N/A", sn: "N/A", vendor: "N/A" }
    });

    return (
        <DeviceContext.Provider value={{ selectedDevice, setSelectedDevice, metrics, setMetrics }}>
            {children}
        </DeviceContext.Provider>
    );
};

export const useDevice = () => useContext(DeviceContext);